import { Decimal } from "decimal.js";
export var toFixed = function toFixed(n, dec) {
  var num = Number(n);
  if (isNaN(num)) {
    return n;
  }
  return new Decimal(n).toFixed(dec, Decimal.ROUND_DOWN).valueOf();
};